import PageTitle from "../PageTitle";
import { SurfaceInfoText } from "../SurfaceInfoText";
import { sectionHeaderStyles } from "./sectionHeader.css";
import { SectionHeaderProps } from "./types";

const SectionHeader = ({ title, description }: SectionHeaderProps) => (
  <header className={sectionHeaderStyles}>
    <PageTitle title={title} />
    {description && <SurfaceInfoText>{description}</SurfaceInfoText>}
  </header>
);

export default SectionHeader;
